import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { TreeMapCell } from '@/lib/trustHub/v1/treemapUtils';

interface TreeMapTooltipProps {
  cell: TreeMapCell;
  children: React.ReactNode;
}

export const TreeMapTooltip: React.FC<TreeMapTooltipProps> = ({ cell, children }) => {
  const totalProviderCount = cell.openaiCount + cell.claudeCount;
  const openaiPercentage = totalProviderCount > 0 ? (cell.openaiCount / totalProviderCount) * 100 : 0;
  const claudePercentage = totalProviderCount > 0 ? (cell.claudeCount / totalProviderCount) * 100 : 0;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <div className="space-y-2">
            <div className="font-semibold text-sm">{cell.domain}</div>
            
            <div className="space-y-1 text-xs">
              <div className="flex justify-between gap-4">
                <span className="text-muted-foreground">Coverage:</span>
                <span className="font-semibold">{cell.coverage.toFixed(1)}%</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="text-muted-foreground">Total citations:</span>
                <span className="font-semibold">{cell.usedCount}</span>
              </div>
            </div>

            <div className="border-t pt-2 space-y-1">
              <div className="text-xs font-medium mb-1">Provider Breakdown:</div>
              {cell.openaiCount > 0 && (
                <div className="flex justify-between items-center text-xs">
                  <span className="flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                    OpenAI
                  </span>
                  <span className="font-semibold">{cell.openaiCount} ({openaiPercentage.toFixed(0)}%)</span>
                </div>
              )}
              {cell.claudeCount > 0 && (
                <div className="flex justify-between items-center text-xs">
                  <span className="flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                    Claude
                  </span>
                  <span className="font-semibold">{cell.claudeCount} ({claudePercentage.toFixed(0)}%)</span>
                </div>
              )}
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
